<template>
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close"
            ><i class="icon-close"></i
          ></a>
          <h3 class="modal-title">公司合併查詢</h3>
        </div>
        <div class="modal-body">
          <table id="merge-table" class="table insurance-green">
            <thead>
              <tr>
                <th width="50%" class="text-center">公司名稱</th>
                <th width="50%" class="text-center">合併或更名後公司名稱</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in mergeList" :key="`merge-item-${i}`">
                <td class="text-center">{{ item.from }}</td>
                <td class="text-center">
                  <span class="arrow text-red">❯</span>
                  {{ item.to }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PropertyCompanyMergeModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    companiesList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    mergeList() {
      return this.companiesList.map((e) => {
        return {
          from: e.OLD_COMPANY_SHORTNAME,
          to: e.NEW_COMPANY_SHORTNAME,
        };
      });
    },
  },
  methods: {},
  mounted() {},
};
</script>
